import type { FaireProductEntity } from "../../entity_types/product";

export const p_43sdpnx5eu: FaireProductEntity = {
  token: "p_43sdpnx5eu",
  type: "product",
  name: "Pa\u02bbakai x Sea Salt Chocolate Bar",
  brandName: "Manoa Chocolate Hawaii",
  imageUrl:
    "https://cdn.faire.com/fastly/bcc89bbcb2757067ea1f16da13c445a5cea5602c1da961e17e6524f1cfa612dc.jpeg",
  priceDollars: 5.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a2ea5d4664dbed8a94e1c3be5abd39796810507abe8f2143aa716d4ca407dd1e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
